<div class="vh-100" *ngIf="checkBrowserCompatibility()">
  <p-dialog header="Session Timeout" [modal]="true" [closable]="false" [(visible)]="showIdleWarning">
    <div class="m-3"><div [innerHtml]="idleState"></div></div>
    <p-footer>
      <button type="button" pButton (click)="reset()" label="Continue"></button>
    </p-footer>
  </p-dialog>
  <app-cap-spinner [animationDuration]="1000"
                   [size]="100"
                   [color]="'#ff1d5e'">
  </app-cap-spinner>
  <div *ngIf="showConfirmPopup()">
    <p-confirmDialog key="signal" header="Confirm"></p-confirmDialog>
  </div>
  <p-confirmDialog header="System Error" icon="pi pi-exclamation-triangle" width="425" class="testerrorconfirm" #cd>
    <p-footer>
      <button type="button" pButton icon="pi pi-check" label="Retry" (click)="cd.accept()"></button>
      <button type="button" pButton icon="pi pi-times" label="Cancel" (click)="cd.reject()"></button>
    </p-footer>
  </p-confirmDialog>
  <div class='container-fluid'>

    <div class='row' style="margin-right:0px;">
      <div class='col-sm-12 body-content'>
        <app-nav-menu></app-nav-menu>
        <router-outlet></router-outlet>

      </div>
    </div>
  </div>
</div>

<div class="vh-100" *ngIf="!checkBrowserCompatibility()">  
  <app-unsupported-browser></app-unsupported-browser>
</div>
